export default __webpack_public_path__ + "static/artificial-intelligence-9c2441586b29530d9d98063b3482aadb.svg";